import { Box, BoxProps } from "@chakra-ui/react";
import { FiEdit } from "react-icons/fi";

export const EditIcon = (props: BoxProps) => {
  return <Box as={FiEdit} height="20px" width="20px" {...props} />;
};
